import { useQuery } from '@tanstack/react-query'

import type { GetEstimateInfoMinimalByIdResponse } from '../../../types/estimate.js'

import { apiClient } from '../../../lib/client.js'
import { estimateKeys } from './keys.js'

export const useGetEstimateInfoMinimalByIdQuery = ({ id }: { id: string }) =>
  useQuery({
    queryFn: async () => {
      const response = await apiClient.client.get<GetEstimateInfoMinimalByIdResponse>(
        `/estimate/info-minimal/${id}`
      )

      return response.data
    },
    queryKey: estimateKeys.infoMinimal(id),
  })
